import {camelizeKeys, decamelizeKeys} from "humps";

export default {
  /**
   * This endpoint will validate the given address parameters will to and verify it for shipping..
   * @param {Object} addressParams - An object that includes the address parameters (first name, last name, address, etc).
   * @returns {Promise<?Object>} - When successful, the address parameters are valid for shipping. When unsuccessful, the response text will indicate the reason the parameters are invalid.
   */
  validateAddress(addressParams) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/address_validation",
        type: "POST",
        data: decamelizeKeys({ address: addressParams }),
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response.responseJSON)
      });
    });
  }
};
